/*eslint-disable*/

import React from "react";
import { TextField, InputAdornment } from "@mui/material";
// import { HiBuildingOffice } from "react-icons/hi2";

interface EditableTextFieldProps {
    label: string;
    name: string;
    value: string;
    isEditing: boolean;
    isEditable?: boolean;
    error: boolean;
    helperText: string;
    forceUpdateKey?: number;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    fontSize?: string; // Optional font size prop
}

const EditableTextField: React.FC<EditableTextFieldProps> = ({
    label,
    name,
    value,
    isEditing,
    isEditable = true,
    error,
    helperText,
    forceUpdateKey,
    onChange,
    fontSize = "1rem", // Default font size if none is provided
}) => {
    return (
        <TextField
            key={forceUpdateKey}
            label={label}
            name={name}
            value={value}
            onChange={onChange}
            disabled={!isEditing || !isEditable}
            fullWidth
            variant="standard"
            error={error}
            helperText={helperText}
            InputLabelProps={{
                shrink: !!value,
                style: { fontSize, padding: "0, 0px" }, // Apply font size to label
            }}
            sx={{
                input: {
                    color: isEditable
                        ? "black !important"
                        : "#6b7280 !important",
                    fontSize, // Apply font size to input
                    padding: "0px 0px", // Adjust padding inside the input field
                },
                "& .MuiInputBase-input.Mui-disabled": {
                    WebkitTextFillColor: isEditable
                        ? "black !important"
                        : "#6b7280 !important",
                    fontSize, // Apply font size to input when disabled
                    padding: "0px 0px", // Adjust padding inside the input field
                },
                "& .MuiInputBase-input::placeholder": {
                    color: "black", // Ensures the placeholder text color is black (optional)
                    padding: "6px 8px", // Adjust padding for placeholder text
                },
                "& .MuiInput-underline:before": {
                    borderBottom: isEditing
                        ? "1px solid #D1D5DB !important"
                        : "none !important",
                },
                "& .MuiInput-underline:after": {
                    borderBottom: isEditing
                        ? "1px solid #D1D5DB !important"
                        : "none !important",
                },
                "& .MuiInput-underline.Mui-error:before": {
                    borderBottom: isEditing ? "1px solid #EF4444" : "none", // Show error border when editing, hide when not
                },
            }}
            // InputProps={{
            //     disableUnderline: !isEditing,
            //     startAdornment: (
            //         <InputAdornment position="start">
            //             <HiBuildingOffice className="text-black" />{" "}
            //             {/* Replace with any icon */}
            //         </InputAdornment>
            //     ),
            // }}
        />
    );
};

export default EditableTextField;
